import { InjectiveExchangeV1Beta1Exchange } from '@injectivelabs/core-proto-ts';
export const TradeExecutionType = {
    Market: 'market',
    LimitFill: 'limitFill',
    LimitMatchRestingOrder: 'limitMatchRestingOrder',
    LimitMatchNewOrder: 'limitMatchNewOrder',
};
export const TradeExecutionSide = {
    Maker: 'maker',
    Taker: 'taker',
};
export const TradeDirection = {
    Buy: 'buy',
    Sell: 'sell',
    Long: 'long',
    Short: 'short',
};
export const OrderMaskMap = InjectiveExchangeV1Beta1Exchange.OrderMask;
